import { isBefore } from 'date-fns';
import { DateStock } from './stockTypes';

export function getStockAmount(
    dateStr: string,
    stocks: DateStock[]
): number | null {
    for (let i = stocks.length - 1; i >= 0; i--) {
        const stock = stocks[i];
        const existingDateStr = stock.date;

        if (dateStr === existingDateStr || isBefore(new Date(existingDateStr), new Date(dateStr))) {
            return stock.amount;
        }
    }

    return null;
}